import script from "./waterStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./waterStatement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__